import { Location } from '../../components/NewSearch/NewSearchLocations/types';

export const getTownshipsCount = (
  townships: Location[] | null,
  chosenLocationIds?: string[] | null
) => {
  if (!townships || !chosenLocationIds) return 0;

  return townships.reduce(
    (count, township) =>
      count + (chosenLocationIds.includes(township.id) ? 1 : 0),
    0
  );
};
